var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-pic-root",class:_vm.homePicClass,style:(_vm.homePicStyle)},[_c('img',{staticClass:"home-pic-image",attrs:{"src":_vm.image}})])}
var staticRenderFns = []

export { render, staticRenderFns }